<div *ngIf="csaladiNezet" class="egyenleg-szulo ion-padding">
  <!-- Egyenleg összegző + nézetváltó -->
  <ion-card class="egyenleg-osszegzo" *ngIf="csegyenleg && egyenleg">
    <ion-card-content>
      <div class="egyenleg-fej">
        <div class="egyenleg-tagok">
          <ion-chip *ngFor="let item of csegyenleg.users" outline>
            <ion-icon [name]="item.type=='szulo' ? 'person' : 'school'"></ion-icon>
            <ion-label>{{ item.nev }}</ion-label>
          </ion-chip>
        </div>
        <div class="egyenleg-ertek">
          <span class="cimke">Egyenleg</span>
          <ion-badge [color]="csegyenleg.egyenleg > 0 ? 'danger' : 'success'">
            {{ csegyenleg.egyenleg | currency: 'HUF' : '' : '0.0' }} Ft
          </ion-badge>
        </div>
      </div>
      <ion-segment [(ngModel)]="legacyNezet" style="margin-top:10px; max-width:340px">
        <ion-segment-button [value]="false"><ion-label>Lista nézet</ion-label></ion-segment-button>
        <ion-segment-button [value]="true"><ion-label>Régi (2 oszlopos)</ion-label></ion-segment-button>
      </ion-segment>
    </ion-card-content>
  </ion-card>

  <!-- Kijelölt bizonylatok egyben fizetése -->
  <div class="bulk-fizetes" *ngIf="!legacyNezet && kijeloltKartyak.length">
    <div class="bulk-info">
      <b>{{ kijeloltKartyak.length }} bizonylat kijelölve</b>
      <span>{{ kijeloltOsszeg | currency: 'HUF' : '' : '0.0' }} Ft</span>
    </div>
    <ion-button size="small" (click)="kijeloltekFizetese()">
      <ion-icon slot="start" name="wallet-outline"></ion-icon>Kijelöltek befizetése
    </ion-button>
  </div>

  <!-- SZÜLŐI bizonylat-nézet: a számlalista (Bizonylatok) minden eleme kártyaként -->
  <div *ngIf="!legacyNezet" class="paired-balance-view">
    <div class="paired-empty" *ngIf="!bizonylatKartyak?.length">
      <ion-icon name="checkmark-done-circle-outline"></ion-icon>
      <strong>Nincs megjeleníthető bizonylat.</strong>
      <span>Jelenleg nem található számla vagy díjbekérő.</span>
    </div>

    <div
      class="paired-item"
      *ngFor="let card of bizonylatKartyak"
      [ngClass]="{
        'paid': card.bizStatus === '1',
        'open': card.bizStatus === '0',
        'overdue': card.bizStatus === '-1'
      }">
      <div class="paired-main">
        <div>
          <div class="paired-title">{{ bizTobbTetel(card) ? (card.szamlaszam || 'Bizonylat') : bizFotetel(card) }}</div>
          <div class="paired-meta">
            <span class="szamlaszam-chip" *ngIf="bizTobbTetel(card) && bizFotetel(card)">{{ bizFotetel(card) }} …</span>
            <span class="szamlaszam-chip" [ngClass]="dokTipusClass(card)" *ngIf="card.szamlaszam">{{ dokTipusLabel(card) }}: {{ card.szamlaszam }}</span>
            <span *ngIf="card.created_at">{{ card.created_at | date:'yyyy.MM.dd' }}</span>
          </div>
        </div>
        <div class="paired-amount">
          <strong>{{ card.osszesen | currency: 'HUF' : '' : '0.0' }} Ft</strong>
          <div class="paired-statusicon" [class.lejart]="card.bizStatus === '-1'" [title]="bizIcon(card.bizStatus).title">
            <img *ngIf="bizIcon(card.bizStatus).src" [src]="bizIcon(card.bizStatus).src" width="32" [alt]="bizIcon(card.bizStatus).title">
            <span class="paired-status-label">{{ bizStatusLabel(card.bizStatus) }}</span>
            <span class="paired-status-nap" *ngIf="bizLejaratSzoveg(card)">{{ bizLejaratSzoveg(card) }}</span>
          </div>
        </div>
      </div>

      <div class="paired-actions">
        <!-- Több bizonylat egyben is kifizethető: egy tranzakció, számlánkénti jóváírás. -->
        <ion-checkbox class="fizetes-kijelolo" *ngIf="bizFizetheto(card) && !feldolgozasAlatt(card.id)"
                      [checked]="kijelolve(card.id)" labelPlacement="end"
                      (ionChange)="fizetesKijelol(card.id, $event.detail.checked)">
          Kijelölés
        </ion-checkbox>
        <ion-button size="small" fill="outline" color="medium"
          [href]="'/api/file/'+sajatIntezmeny?.intezmenyId+'/invoice/'+card.id+'.pdf'" target="_blank">
          <ion-icon slot="start" name="document-outline"></ion-icon>Letöltés
        </ion-button>
        <ion-button size="small" [color]="dokTipusClass(card)==='dijbekero' ? 'tertiary' : 'primary'"
          *ngIf="bizFizetheto(card) && fizetesMod.stripe && !feldolgozasAlatt(card.id)"
          (click)="fizetesMegnyit(card.id, 'stripe')">
          <ion-icon slot="start" name="card-outline"></ion-icon>{{ fizetesFelirat(dokTipusClass(card)==='dijbekero' ? 'Díjbekérő befizetése' : 'Befizetés', 'stripe') }}
        </ion-button>
        <!-- OTP SimplePay -->
        <ion-button size="small" [color]="dokTipusClass(card)==='dijbekero' ? 'tertiary' : 'primary'"
          *ngIf="bizFizetheto(card) && fizetesMod.simple && !feldolgozasAlatt(card.id)"
          (click)="fizetesMegnyit(card.id, 'simple')">
          <ion-icon slot="start" name="wallet-outline"></ion-icon>{{ fizetesFelirat(dokTipusClass(card)==='dijbekero' ? 'Díjbekérő befizetése' : 'Befizetés', 'simple') }}
        </ion-button>
        <!-- NINCS AKTÍV FIZETŐKAPU. A gomb elrejtése önmagában néma: a szülő azt
             látná, hogy nincs is fizetési lehetőség, és nem tudná, miért. -->
        <ion-chip *ngIf="bizFizetheto(card) && nincsFizetokapu && !feldolgozasAlatt(card.id)"
                  color="medium" class="fizetes-folyamatban">
          <ion-icon name="card-outline"></ion-icon>
          <ion-label>Jelenleg nem aktív egy fizetőkapu sem</ion-label>
        </ion-chip>
        <!-- Fizetés megérkezett, a könyvelés még fut: gomb helyett jelzés, hogy ne fizessen újra -->
        <ion-chip *ngIf="bizFizetheto(card) && feldolgozasAlatt(card.id)" color="warning" class="fizetes-folyamatban">
          <ion-spinner name="dots"></ion-spinner>
          <ion-label>Fizetés feldolgozása – a számla készül</ion-label>
        </ion-chip>
      </div>

      <!-- Díjbekérőből kiállított végszámla (összevonva, egy kártyában) -->
      <div class="paired-credit-list" *ngIf="card.vegszamla">
        <div class="paired-credit auto">
          <ion-icon name="checkmark-circle-outline"></ion-icon>
          <span>Számla kiállítva</span>
          <small>{{ card.vegszamlaszam }}</small>
          <ion-button size="small" fill="clear" color="medium"
            [href]="'/api/file/'+sajatIntezmeny?.intezmenyId+'/invoice/'+card.vegszamla+'.pdf'" target="_blank">
            <ion-icon slot="start" name="download-outline"></ion-icon>Letöltés
          </ion-button>
        </div>
      </div>
    </div>
  </div>

  <!-- LEGACY 2-oszlopos nézet -->
  <ion-grid *ngIf="legacyNezet">
    <ion-row>
      <ion-col size="6">
        <h1>Követelések</h1>
        <ngx-datatable (select)="onSelect($event)"
          class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz" [rows]="kovetel"
          [sortType]="SortType.single" [columnMode]="ColumnMode.force" [rowClass]="getRowClass"
          [sorts]="[{ prop: 'date', dir: 'desc' }]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
          <ngx-datatable-column name="Név" prop="nev">
            <ng-template let-value="value" ngx-datatable-cell-template><b class="mobil">Név</b>{{ value }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Összeg" prop="osszeg">
            <ng-template let-value="value" ngx-datatable-cell-template><b class="mobil">Összeg</b>{{ value | currency: 'HUF' : '' : '0.0' }} Ft</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Dátum" prop="date">
            <ng-template let-value="value" ngx-datatable-cell-template><b class="mobil">Dátum</b><span *ngIf="value">{{ value }}</span></ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </ion-col>
      <ion-col size="6">
        <h1>Jóváírások</h1>
        <ngx-datatable (select)="onSelect($event)"
          class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz" [rows]="jovair"
          [sortType]="SortType.single" [columnMode]="ColumnMode.force" [rowClass]="getRowClass"
          [sorts]="[{ prop: 'date', dir: 'desc' }]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
          <ngx-datatable-column name="Név" prop="nev">
            <ng-template let-value="value" ngx-datatable-cell-template><b class="mobil">Név</b>{{ value }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Összeg" prop="osszeg">
            <ng-template let-value="value" ngx-datatable-cell-template><b class="mobil">Összeg</b>{{ value | currency: 'HUF' : '' : '0.0' }} Ft</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Dátum" prop="date">
            <ng-template let-value="value" ngx-datatable-cell-template><b class="mobil">Dátum</b><span *ngIf="value">{{ value }}</span></ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>



<ion-grid *ngIf="!csaladiNezet">
  <ion-row>
    <ion-col size="10">
      <ion-select aria-label="Egyenleg típusa" interface="popover" placeholder="" label="Egyenleg típusa"
        (ionChange)="fotipusvalt($event)" label-placement="stacked" fill="outline"
        [value]="egyenlegMode"><!-- style="min-height: 56px; border: 0; cursor: pointer"-->
        <ion-select-option value="1">Család</ion-select-option>
        <ion-select-option value="2">Osztály</ion-select-option>
      </ion-select>
    </ion-col>
    <ion-col size="auto">
      <ion-button color="danger" (click)="tomegesInit()" title="Tömeges ebédkiírás">
                <ion-icon slot="start" name="restaurant"></ion-icon> Tömeges ebédkiírás
                </ion-button>
    </ion-col>
  </ion-row>
  <ion-row *ngIf="egyenlegMode=='1'">
    <ion-col>


      <ng-container *ngIf="egyenleg">
        <ngx-datatable (select)="onSelect($event)"
          class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz selectable checkbox-selection"
          [rows]="egyenleg" [sortType]="SortType.single" [columnMode]="ColumnMode.force" [rowHeight]="'auto'"
          [selected]="selected" [selectionType]="SelectionType.checkbox" [rowClass]="getRowClass" [sorts]="[
  { prop: 'created_at', dir: 'desc' },
  { prop: 'updated_at', dir: 'desc' },
  { prop: 'priority', dir: 'desc' },
  { prop: 'deadline', dir: 'desc' }
]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
          <ngx-datatable-column [width]="30" [sortable]="false" [canAutoResize]="false" [draggable]="false"
            [resizeable]="false">
            <ng-template ngx-datatable-header-template let-value="value" let-allRowsSelected="allRowsSelected"
              let-selectFn="selectFn">
              <input type="checkbox" [checked]="allRowsSelected" (change)="selectFn(!allRowsSelected)" />
            </ng-template>
            <ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected"
              let-onCheckboxChangeFn="onCheckboxChangeFn">
              <input type="checkbox" [checked]="isSelected" (change)="onCheckboxChangeFn($event)" />
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Család" prop="csalad_reszletek">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template style="overflow-wrap:break-word">
              <b class="mobil">Család</b>
              <span *ngIf="value"><span *ngFor="let item of JSON.parse(value)">{{ item.nev }} <span
                    *ngIf="item.type == 'szulo'">&lt;gondviselő&gt;</span><span
                    *ngIf="item.type != 'szulo'">&lt;tanuló&gt;</span><br> </span></span>

            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Egyenleg" prop="egyenleg">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Egyenleg</b>
              <span>{{ value | currency: 'HUF' : '' : '0.0' }} Ft</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Műveletek">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template let-i="rowIndex">
              <b class="mobil">Műveletek</b>
              <ion-button color="secondary" size="small" style="margin-top:0" title="Egyenleg"
                (click)="initModal(JSON.parse(row.users)[0],egyenleg.indexOf(row))">
                <ion-icon slot="icon-only" name="eye"></ion-icon>

              </ion-button>
              <ion-button color="success" size="small" style="margin-top:0" title="Tételkiírás"
                (click)="initModal2(JSON.parse(row.users)[0],egyenleg.indexOf(row))">
                <ion-icon slot="icon-only" name="add-circle"></ion-icon>

              </ion-button>
              <!-- A bizonylat-kiállítás átkerült a külön "Új bizonylat" almenübe (penzugy/ujbizonylat). -->
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </ng-container>



    </ion-col>
  </ion-row>
  <ion-row *ngIf="egyenlegMode=='2'">
    <ion-col>

      <!-- TANÉV-VÁLASZTÓ. Alapból a futó tanév látszik: tanévváltáskor minden osztály
           új sorként jön létre, és a tavalyiak ugyanazokkal a nevekkel álltak az idei
           mellett. A korábbi évek egyenlege nem veszett el, itt előhívható. -->
      <div class="tanev-valaszto" *ngIf="osztalyEvek?.length > 1">
        <ion-select label="Tanév" label-placement="stacked" fill="outline" interface="popover"
                    [ngModel]="valasztottTanev" (ngModelChange)="tanevValt($event)">
          <ion-select-option [value]="null">Futó tanév</ion-select-option>
          <ion-select-option *ngFor="let e of osztalyEvek" [value]="e">
            {{ e }}/{{ e + 1 }}<span *ngIf="e === aktualisTanev"> — ez a futó</span>
          </ion-select-option>
        </ion-select>
        <small *ngIf="valasztottTanev && valasztottTanev !== aktualisTanev">
          Lezárt tanévet nézel: ezek a sorok már nem élők.
        </small>
      </div>

      <ng-container *ngIf="oegyenleg">
        <ngx-datatable (select)="onSelect($event)"
          class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz selectable checkbox-selection"
          [rows]="oegyenleg" [sortType]="SortType.single" [columnMode]="ColumnMode.force" [rowHeight]="'auto'"
          [rowClass]="getRowClass" [sorts]="[
  { prop: 'created_at', dir: 'desc' },
  { prop: 'updated_at', dir: 'desc' },
  { prop: 'priority', dir: 'desc' },
  { prop: 'deadline', dir: 'desc' }
]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
          <ngx-datatable-column name="Osztály" prop="osztaly">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template style="overflow-wrap:break-word">
              <b class="mobil">Osztály</b>
              <span *ngIf="value">{{row.osztaly}} &lt;{{row.viselt_vez}} {{row.viselt_ker}}&gt;</span>

            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Egyenleg" prop="egyenleg">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Egyenleg</b>
              <span>{{ value | currency: 'HUF' : '' : '0.0' }} Ft</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Műveletek">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template let-i="rowIndex">
              <b class="mobil">Műveletek</b>
              <ion-button color="secondary" size="small" style="margin-top:0" title="Egyenleg"
                (click)="initOsztalyModal(row.id,oegyenleg.indexOf(row))">
                <ion-icon slot="icon-only" name="eye"></ion-icon>

              </ion-button>
              <ion-button color="success" size="small" style="margin-top:0" title="Tételkiírás"
                (click)="initOsztalyModal2(row.id,oegyenleg.indexOf(row))">
                <ion-icon slot="icon-only" name="add-circle"></ion-icon>

              </ion-button>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </ng-container>



    </ion-col>
  </ion-row>
</ion-grid>


<ion-modal class="" style="z-index: 1000" #tetelmodal trigger="tetel">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-button (click)="cancel2()">Mégse</ion-button>
        </ion-buttons>
        <ion-title>Új Tétel</ion-title>
        <ion-buttons slot="end">
          <ion-button [disabled]="!tetel.valid" style="background: white; border-radius: 5px" (click)="confirm2()"
            [strong]="true" shape="round" color="secondary">Mentés</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding" style="margin: auto;">
      <table style="width: 100%;" border="1">
        <thead>

        </thead>
        <tbody *ngIf="egyenleg && csegyenlegid && egyenleg[csegyenlegid]">
          <tr *ngFor="let item of JSON.parse(egyenleg[csegyenlegid].csalad_reszletek)">
            <td *ngIf="item.type=='szulo'">Gondviselő</td>
            <td *ngIf="item.type!='szulo'">Tanuló</td>
            <td>{{item.nev}}</td>
          </tr>
          <tr>
            <td [class]="csegyenleg.egyenleg >= 0 ? 'row-color-blue' : 'row-color-green'"><b>Egyenleg</b></td>
            <td [class]="csegyenleg.egyenleg >= 0 ? 'row-color-blue' : 'row-color-green'"><b>{{csegyenleg.egyenleg | currency: 'HUF' : '' : '0.0'}}
                Ft</b></td>
          </tr>
        </tbody>
      </table>
      <hr>
      <form [formGroup]="tetel">
        <ion-select aria-label="Tétel típus" interface="popover" placeholder="" label="Tétel típus"
          (ionChange)="tipusValt()" formControlName="tipus" label-placement="stacked" fill="outline">
          <ion-icon slot="start" name="bookmarks" aria-hidden="true"></ion-icon>
          <ion-select-option value="Követelés alrendszerből">Követelés alrendszerből</ion-select-option>
          <ion-select-option value="Követelés">Követelés</ion-select-option>
          <ion-select-option value="Jóváírás alrendszerből">Jóváírás alrendszerből</ion-select-option>
          <ion-select-option value="Jóváírás">Jóváírás</ion-select-option>
          <ion-select-option value="Jóváírás követelésből" [disabled]="kovetelnullaz.length==0">Jóváírás
            követelésből</ion-select-option>
        </ion-select><br>
        <ion-select aria-label="Alrendszer" interface="popover" placeholder="" label="Alrendszer"
          *ngIf="tetel.value.tipus == 'Követelés alrendszerből' || tetel.value.tipus == 'Jóváírás alrendszerből'"
          formControlName="alrendszer" label-placement="stacked" fill="outline">
          <ion-icon slot="start" name="bookmarks" aria-hidden="true"></ion-icon>
          <ion-select-option value="Étkezés">Étkezés</ion-select-option>
        </ion-select><br
          *ngIf="tetel.value.tipus == 'Követelés alrendszerből' || tetel.value.tipus == 'Jóváírás alrendszerből'">
        <ion-row
          *ngIf="tetel.value.tipus == 'Követelés alrendszerből' || tetel.value.tipus == 'Jóváírás alrendszerből'">
          <ion-col>
            <ion-input label="Év" label-placement="stacked" fill="outline" placeholder="" type="number"
              formControlName="ev">
              <ion-icon slot="start" name="pricetag" aria-hidden="true"></ion-icon>
            </ion-input>
          </ion-col>
          <ion-col>
            <ion-select aria-label="Hónap" interface="popover" placeholder="" label="Hónap" (ionChange)="tipusValt()"
              formControlName="honap" label-placement="stacked"
              fill="outline"><!-- style="min-height: 56px; border: 0; cursor: pointer"-->
              <ion-select-option value="1">Január</ion-select-option>
              <ion-select-option value="2">Február</ion-select-option>
              <ion-select-option value="3">Március</ion-select-option>
              <ion-select-option value="4">Április</ion-select-option>
              <ion-select-option value="5">Május</ion-select-option>
              <ion-select-option value="6">Június</ion-select-option>
              <ion-select-option value="7">Július</ion-select-option>
              <ion-select-option value="8">Augusztus</ion-select-option>
              <ion-select-option value="9">Szeptember</ion-select-option>
              <ion-select-option value="10">Október</ion-select-option>
              <ion-select-option value="11">November</ion-select-option>
              <ion-select-option value="12">December</ion-select-option>
            </ion-select>
          </ion-col>
        </ion-row>
        <!-- Kétheti (félhavi) számlázás: a hónapon belüli nap-tartomány. -->
        <ion-row
          *ngIf="tetel.value.tipus == 'Követelés alrendszerből' || tetel.value.tipus == 'Jóváírás alrendszerből'">
          <ion-col size="12">
            <ion-select aria-label="Időszak" interface="popover" label="Időszak" (ionChange)="tipusValt()"
              formControlName="idoszak" label-placement="stacked" fill="outline">
              <ion-icon slot="start" name="calendar" aria-hidden="true"></ion-icon>
              <ion-select-option *ngFor="let o of idoszakOpciok" [value]="o.id">{{ o.nev }}</ion-select-option>
            </ion-select>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="tetel.value.idoszak == 'egyedi' &&
          (tetel.value.tipus == 'Követelés alrendszerből' || tetel.value.tipus == 'Jóváírás alrendszerből')">
          <ion-col>
            <ion-input label="Ettől a naptól" label-placement="stacked" fill="outline" type="number" min="1" max="31"
              formControlName="nap_tol" (ionChange)="tipusValt()"></ion-input>
          </ion-col>
          <ion-col>
            <ion-input label="Eddig a napig" label-placement="stacked" fill="outline" type="number" min="1" max="31"
              formControlName="nap_ig" (ionChange)="tipusValt()"></ion-input>
          </ion-col>
        </ion-row>
        <ion-select aria-label="Követelés" interface="popover" placeholder="" label="Követelés"
          *ngIf="tetel.value.tipus == 'Jóváírás követelésből'" (ionChange)="getAdatFromKoveteles($event)"
          formControlName="koveteles" label-placement="stacked" fill="outline">
          <ion-icon slot="start" name="bookmarks" aria-hidden="true"></ion-icon>
          <ion-select-option [value]="item" *ngFor="let item of kovetelnullaz">{{item.nev}} - {{item.osszeg}} Ft -
            {{item.date}}</ion-select-option>
        </ion-select>
        <br>
        <ion-input label="Megnevezés" label-placement="stacked" fill="outline" placeholder="" formControlName="nev">
          <ion-icon slot="start" name="pricetag" aria-hidden="true"></ion-icon>
        </ion-input><br >
        <ion-button (click)="getAdatFromAlrendszer()" expand="block" color="primary"
          *ngIf="tetel.value.tipus == 'Követelés alrendszerből' || tetel.value.tipus == 'Jóváírás alrendszerből'">Összeg
          lekérése</ion-button>

        <br
          *ngIf="tetel.value.tipus == 'Követelés alrendszerből' || tetel.value.tipus == 'Jóváírás alrendszerből' || tetel.value.tipus == 'Jóváírás követelésből'">
        <ion-input label="Összeg" label-placement="stacked" fill="outline" placeholder="" type="number"
          formControlName="osszeg"
          [disabled]="tetel.value.tipus == 'Követelés alrendszerből' || tetel.value.tipus == 'Jóváírás alrendszerből' || tetel.value.tipus == 'Jóváírás követelésből'">
          <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
          <span fill="clear" slot="end" aria-label="Show/hide">
            Ft
          </span>
        </ion-input><br>
        <div
          class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
          <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
            <div class="input-outline-container sc-ion-input-md">
              <div class="input-outline-start sc-ion-input-md"></div>
              <div class="input-outline-end sc-ion-input-md"></div>
            </div>
            <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">

              <ion-checkbox formControlName="dijbekero" labelPlacement="start" style="width: 100%; height: 100%;"
                [disabled]="false">
                Bizonylat kiállítása</ion-checkbox>
            </div>
          </label>
        </div><br>
        <ion-select aria-label="Bizonylattömb" interface="popover" placeholder="" label="Bizonylattömb" [disabled]="tetel.value.dijbekero != 'true'"
           formControlName="biztomb" label-placement="stacked" fill="outline">
          <ion-icon slot="start" name="bookmarks" aria-hidden="true"></ion-icon>
          <ion-select-option *ngFor="let t of tombok" [value]="t.id">{{t.elotag}}</ion-select-option>
        </ion-select><br>
      </form>
    </ion-content>
  </ng-template>
</ion-modal>



<ion-modal class="" style="z-index: 1000" #osztalytetelmodal trigger="osztalytetel">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-button (click)="cancelosztaly2()">Mégse</ion-button>
        </ion-buttons>
        <ion-title>Új Tétel</ion-title>
        <ion-buttons slot="end">
          <ion-button [disabled]="!osztalytetel.valid" style="background: white; border-radius: 5px" (click)="confirmosztaly2()"
            [strong]="true" shape="round" color="secondary">Mentés</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding" style="margin: auto;">
      <table style="width: 100%;" border="1">
        <thead>

        </thead>
        <tbody>
          <tr>
            <td>Osztályfőnök</td>
            <td>{{oegyenleg[csegyenlegid].viselt_vez}} {{oegyenleg[csegyenlegid].viselt_ker}}</td>
          </tr>
          <tr *ngFor="let zseb of zsebek">
            <td [class]="csegyenleg.zseb_egyenlegek[zseb.nev] >= 0 ? 'row-color-green' : 'row-color-blue'"><b>{{zseb.nev}} zseb</b></td>
            <td [class]="csegyenleg.zseb_egyenlegek[zseb.nev] >= 0 ? 'row-color-green' : 'row-color-blue'"><b>{{csegyenleg.zseb_egyenlegek[zseb.nev] || 0}}
                Ft</b></td>
          </tr>
          <tr style="border-top:2px solid">
            <td [class]="csegyenleg.egyenleg >= 0 ? 'row-color-green' : 'row-color-blue'"><b>Összesített egyenleg</b></td>
            <td [class]="csegyenleg.egyenleg >= 0 ? 'row-color-green' : 'row-color-blue'"><b>{{csegyenleg.egyenleg}}
                Ft</b></td>
          </tr>
        </tbody>
      </table>
      <hr>
      <form [formGroup]="osztalytetel">
        <ion-select aria-label="Tétel típus" interface="popover" placeholder="" label="Tétel típus"
          formControlName="tipus" label-placement="stacked" fill="outline">
          <ion-icon slot="start" name="bookmarks" aria-hidden="true"></ion-icon>
          <ion-select-option value="Követelés">Kiadás</ion-select-option>
          <ion-select-option value="Jóváírás">Bevétel</ion-select-option>
        </ion-select><br>
        <ion-select aria-label="Zseb" interface="popover" placeholder="" label="Zseb"
          formControlName="zseb" label-placement="stacked" fill="outline">
          <ion-icon slot="start" name="bookmarks" aria-hidden="true"></ion-icon>
          <ion-select-option *ngFor="let item of zsebek" [value]="item.id">{{item.nev}}</ion-select-option>
        </ion-select>
        <br>
        <ion-input label="Megnevezés" label-placement="stacked" fill="outline" placeholder="" formControlName="nev">
          <ion-icon slot="start" name="pricetag" aria-hidden="true"></ion-icon>
        </ion-input><br >
        <ion-input label="Számlaszám" label-placement="stacked" fill="outline" placeholder="" formControlName="szla" *ngIf="osztalytetel.value.tipus=='Követelés'">
          <ion-icon slot="start" name="pricetag" aria-hidden="true"></ion-icon>
        </ion-input><br *ngIf="osztalytetel.value.tipus=='Követelés'">
        <ion-input label="Összeg" label-placement="stacked" fill="outline" placeholder="" type="number"
          formControlName="osszeg"
          ><ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
          <span fill="clear" slot="end" aria-label="Show/hide">
            Ft
          </span>
        </ion-input>
      </form>
    </ion-content>
  </ng-template>
</ion-modal>




<ion-modal class="nagy" style="z-index: 1000" #uzenetmodal trigger="uzenet">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-button (click)="cancel()">Bezár</ion-button>
        </ion-buttons>
        <ion-title>Egyenlegközlő</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <table style="width: 100%;" border="1">
        <thead>

        </thead>
        <tbody>
          <tr *ngFor="let item of JSON.parse(egyenleg[csegyenlegid].csalad_reszletek)">
            <td *ngIf="item.type=='szulo'">Gondviselő</td>
            <td *ngIf="item.type!='szulo'">Tanuló</td>
            <td>{{item.nev}}</td>
          </tr>
          <tr>
            <td [class]="csegyenleg.egyenleg >= 0 ? 'row-color-blue' : 'row-color-green'"><b>Egyenleg</b></td>
            <td [class]="csegyenleg.egyenleg >= 0 ? 'row-color-blue' : 'row-color-green'"><b>{{csegyenleg.egyenleg | currency: 'HUF' : '' : '0.0'}}
                Ft</b></td>
          </tr>
        </tbody>
      </table>


      <!--ion-segment value="3" color="primary" [scrollable]="true" [(ngModel)]="segment">
        <ion-segment-button value="1" layout="icon-start">
          <ion-label>Követelések</ion-label>
          <ion-icon name="log-out"></ion-icon>
        </ion-segment-button>
        <ion-segment-button value="2" layout="icon-start">
          <ion-label>Jóváírások</ion-label>
          <ion-icon name="log-in"></ion-icon>
        </ion-segment-button>
        <ion-segment-button value="3" layout="icon-start">
          <ion-label>Összegzés</ion-label>
          <ion-icon name="add-circle"></ion-icon>
        </ion-segment-button>
      </ion-segment>
      <hr-->

      <div class="egyenleg-view-switcher">
        <ion-segment [(ngModel)]="egyenlegModalView" value="parositott">
          <ion-segment-button value="parositott">
            <ion-icon name="git-compare-outline"></ion-icon>
            <ion-label>Párosított nézet</ion-label>
          </ion-segment-button>
          <ion-segment-button value="tablazat">
            <ion-icon name="grid-outline"></ion-icon>
            <ion-label>Táblázatos nézet</ion-label>
          </ion-segment-button>
        </ion-segment>
      </div>

      <div *ngIf="egyenlegModalView === 'parositott'" class="paired-balance-view">
        <div class="paired-empty" *ngIf="!parositottTetelek?.length && !parositatlanJovairasok?.length">
          <ion-icon name="checkmark-done-circle-outline"></ion-icon>
          <strong>Nincs megjeleníthető pénzügyi tétel.</strong>
          <span>Ehhez a családhoz jelenleg nem található követelés vagy jóváírás.</span>
        </div>

        <div
          class="paired-item"
          *ngFor="let item of parositottTetelek"
          [ngClass]="{
            'paid': getTetelStatus(item) === 'paid',
            'partial': getTetelStatus(item) === 'partial',
            'open': getTetelStatus(item) === 'open',
            'overdue': tetelLejart(item)
          }">
          <div class="paired-main">
            <div>
              <div class="paired-title">{{ szamlaTobbTetel(item) ? (item.kovetel?.szamlaszam || 'Számla') : item.kovetel?.nev }}</div>
              <div class="paired-meta">
                <span class="szamlaszam-chip" *ngIf="szamlaTobbTetel(item) && item.kovetel?.nev">{{ item.kovetel.nev }}</span>
                <span class="szamlaszam-chip" [class.dijbekero]="isDijbekero(item.kovetel)"
                  *ngIf="!szamlaTobbTetel(item) && item.kovetel?.szamlaszam">{{ dokTipusLabel(item.kovetel) }}: {{ item.kovetel.szamlaszam }}</span>
                <span *ngIf="item.kovetel?.date">{{ item.kovetel.date }}</span>
                <span *ngIf="item.kovetel?.alrendszer">{{ item.kovetel.alrendszer }}</span>
              </div>
            </div>
            <div class="paired-amount">
              <strong>{{ item.kovetel?.osszeg | currency: 'HUF' : '' : '0.0' }} Ft</strong>
              <div class="paired-statusicon" [class.lejart]="tetelLejart(item)" [title]="getTetelIcon(item).title">
                <img [src]="getTetelIcon(item).src" width="32" [alt]="getTetelIcon(item).title">
                <span class="paired-status-label">{{ getTetelStatusLabel(item) }}</span>
                <span class="paired-status-nap" *ngIf="tetelLejaratSzoveg(item)">{{ tetelLejaratSzoveg(item) }}</span>
              </div>
            </div>
          </div>

          <!-- Bizonylat letöltés + befizetés (díjbekérő/számla) -->
          <div class="paired-actions" *ngIf="item.kovetel?.szamla">
            <ion-button size="small" fill="outline" color="medium"
              [href]="'/api/file/'+sajatIntezmeny?.intezmenyId+'/invoice/'+item.kovetel.szamla+'.pdf'" target="_blank">
              <ion-icon slot="start" name="document-outline"></ion-icon>Letöltés
            </ion-button>
            <ion-button size="small" [color]="isDijbekero(item.kovetel) ? 'tertiary' : 'primary'"
              *ngIf="tetelFizetheto(item) && fizetesMod.stripe && !feldolgozasAlatt(item.kovetel.szamla)"
              [href]="'/api/checkout/form?id='+item.kovetel.szamla" target="_blank">
              <ion-icon slot="start" name="card-outline"></ion-icon>{{ fizetesFelirat(isDijbekero(item.kovetel) ? 'Díjbekérő befizetése' : 'Befizetés', 'stripe') }}
            </ion-button>
            <!-- OTP SimplePay -->
            <ion-button size="small" [color]="isDijbekero(item.kovetel) ? 'tertiary' : 'primary'"
              *ngIf="tetelFizetheto(item) && fizetesMod.simple && !feldolgozasAlatt(item.kovetel.szamla)"
              [href]="'/api/simplepay/form?id='+item.kovetel.szamla" target="_blank">
              <ion-icon slot="start" name="wallet-outline"></ion-icon>{{ fizetesFelirat(isDijbekero(item.kovetel) ? 'Díjbekérő befizetése' : 'Befizetés', 'simple') }}
            </ion-button>
            <ion-chip *ngIf="tetelFizetheto(item) && feldolgozasAlatt(item.kovetel.szamla)" color="warning"
                      class="fizetes-folyamatban">
              <ion-spinner name="dots"></ion-spinner>
              <ion-label>Fizetés feldolgozása – a számla készül</ion-label>
            </ion-chip>
          </div>

          <!-- ADMIN: hibásan kiírt tétel javítása / törlése, díjbekérő érvénytelenítése -->
          <div class="paired-actions" *ngIf="adminTetel() && item.kovetel?.id">
            <ng-container *ngIf="tetelSzerk?.id !== item.kovetel.id">
              <ion-button size="small" fill="outline" color="medium" [disabled]="tetelMuvelet"
                (click)="tetelSzerkNyit(item.kovetel)" title="A kiírás megnevezésének és összegének javítása">
                <ion-icon slot="start" name="create-outline"></ion-icon>Javítás
              </ion-button>
              <ion-button size="small" fill="outline" color="danger" [disabled]="tetelMuvelet"
                (click)="tetelTorol(item.kovetel)" title="A hibásan kiírt tétel törlése">
                <ion-icon slot="start" name="trash-outline"></ion-icon>Törlés
              </ion-button>
              <ion-button size="small" fill="outline" color="warning" [disabled]="tetelMuvelet"
                *ngIf="isDijbekero(item.kovetel) && item.kovetel?.szamla"
                (click)="dijbekeroErvenytelenit(item.kovetel)"
                title="A díjbekérő érvénytelenítése – a sorszám megmarad, a kiírás felszabadul">
                <ion-icon slot="start" name="close-circle-outline"></ion-icon>Díjbekérő érvénytelenítése
              </ion-button>
            </ng-container>
            <ng-container *ngIf="tetelSzerk?.id === item.kovetel.id">
              <ion-input style="min-width:220px" fill="outline" label="Megnevezés" labelPlacement="stacked"
                [(ngModel)]="tetelSzerk.nev"></ion-input>
              <ion-input style="max-width:140px" fill="outline" label="Összeg (Ft)" labelPlacement="stacked"
                type="number" [(ngModel)]="tetelSzerk.osszeg"></ion-input>
              <ion-button size="small" color="success" [disabled]="tetelMuvelet" (click)="tetelSzerkMent()">
                <ion-icon slot="start" name="save-outline"></ion-icon>Mentés
              </ion-button>
              <ion-button size="small" fill="clear" color="medium" (click)="tetelSzerkMegse()">Mégse</ion-button>
            </ng-container>
          </div>

          <div class="paired-progress">
            <div>
              <span>Befizetve</span>
              <strong>{{ item.befizetve | currency: 'HUF' : '' : '0.0' }} Ft</strong>
            </div>
            <div>
              <span>Hátralék</span>
              <strong>{{ getTetelMaradek(item) | currency: 'HUF' : '' : '0.0' }} Ft</strong>
            </div>
          </div>

          <div class="paired-credit-list" *ngIf="item.jovairasok?.length">
            <div class="paired-credit" *ngFor="let jovairas of item.jovairasok"
              [class.auto]="isAutoParositott(item, jovairas)"
              [title]="isAutoParositott(item, jovairas) ? 'Automatikusan párosítva (név/összeg egyezés alapján)' : ''">
              <ion-icon [name]="isAutoParositott(item, jovairas) ? 'git-compare-outline' : 'arrow-down-circle-outline'"></ion-icon>
              <span>{{ jovairas.nev }}</span>
              <small *ngIf="jovairas.date || jovairas.szamlaszam">
            <span class="credit-szamlaszam" *ngIf="jovairas.szamlaszam"
              [ngClass]="dokTipusClass(jovairas)">{{ dokTipusLabel(jovairas) }} {{ jovairas.szamlaszam }}</span>
            <span *ngIf="jovairas.date"> {{ jovairas.date }}</span>
          </small>
              <strong>{{ (jovairas.osszeg * -1) | currency: 'HUF' : '' : '0.0' }} Ft</strong>
            </div>
          </div>

          <div class="paired-no-credit" *ngIf="!item.jovairasok?.length">
            Ehhez a követeléshez még nincs társított befizetés.
          </div>
        </div>

        <div class="unmatched-credits" *ngIf="parositatlanJovairasok?.length">
          <h3>Nem társított befizetések</h3>
          <div class="paired-credit unmatched" *ngFor="let jovairas of parositatlanJovairasok">
            <ion-icon name="wallet-outline"></ion-icon>
            <span>{{ jovairas.nev }}</span>
            <small *ngIf="jovairas.date || jovairas.szamlaszam">
            <span class="credit-szamlaszam" *ngIf="jovairas.szamlaszam"
              [ngClass]="dokTipusClass(jovairas)">{{ dokTipusLabel(jovairas) }} {{ jovairas.szamlaszam }}</span>
            <span *ngIf="jovairas.date"> {{ jovairas.date }}</span>
          </small>
            <strong>{{ (jovairas.osszeg * -1) | currency: 'HUF' : '' : '0.0' }} Ft</strong>
            <ion-select class="parosit-select" *ngIf="parosithat && parositasraFelkinalt.length"
              interface="popover" placeholder="Párosítás követeléshez…" label-placement="stacked"
              (ionChange)="parositJovairast(jovairas, $event.detail.value)">
              <ion-select-option *ngFor="let it of parositasraFelkinalt" [value]="it.kovetel?.id">
                {{ it.kovetel?.nev }} ({{ it.kovetel?.osszeg | currency: 'HUF' : '' : '0.0' }} Ft)
              </ion-select-option>
            </ion-select>
          </div>
        </div>
      </div>

      <form [formGroup]="form" *ngIf="egyenlegModalView === 'tablazat'">
        <ion-grid>
          <!--ion-row *ngIf="segment=='1'">

            <ion-col>
              <div style="margin-top: 10px;">
                <ion-button color="primary" (click)="initModal2(csegyenlegid,0,'Követelés')">
                  <ion-icon slot="start" name="add"></ion-icon>
                  Új követelés
                </ion-button>
              </div>
              <ng-container>
                <ngx-datatable (select)="onSelect($event)"
                  class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz" [rows]="kovetel"
                  [sortType]="SortType.single" [columnMode]="ColumnMode.force"  [rowClass]="getRowClass"
                  [sorts]="[
  { prop: 'date', dir: 'desc' }
]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
                  <ngx-datatable-column name="Név" prop="nev">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Név</b>
                      {{ value }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Összeg" prop="osszeg">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Összeg</b>
                      {{ value }} Ft
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Modul" prop="alrendszer">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                      <b class="mobil">Modul</b>
                      {{ value }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Dátum" prop="date">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Dátum</b>
                      <span *ngIf="value">{{ value }}</span>
                    </ng-template>
                  </ngx-datatable-column>

                </ngx-datatable>
              </ng-container>

            </ion-col>
          </ion-row>



          <ion-row *ngIf="segment=='2'">
            <ion-col>
              <div style="margin-top: 10px;">
                <ion-button color="primary" (click)="initModal2(csegyenlegid,0,'Jóváírás')">
                  <ion-icon slot="start" name="add"></ion-icon>
                  Új jóváírás
                </ion-button>
              </div>
              <ng-container>
                <ngx-datatable (select)="onSelect($event)"
                  class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz" [rows]="jovair"
                  [sortType]="SortType.single" [columnMode]="ColumnMode.force"  [rowClass]="getRowClass"
                  [sorts]="[
        { prop: 'date', dir: 'desc' }
      ]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
                  <ngx-datatable-column name="Név" prop="nev">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Név</b>
                      {{ value }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Összeg" prop="osszeg">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Összeg</b>
                      {{ -value }} Ft
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Modul" prop="alrendszer">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                      <b class="mobil">Modul</b>
                      {{ value }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Dátum" prop="date">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Dátum</b>
                      <span *ngIf="value">{{ value }}</span>
                    </ng-template>
                  </ngx-datatable-column>

                </ngx-datatable>
              </ng-container>

            </ion-col>
          </ion-row-->



          <ion-row><!-- *ngIf="segment=='3'"-->
            <ion-col size="6">
              <!--div style="margin-top: 10px;">
                <ion-button color="primary" (click)="initModal2(csegyenlegid,0,'Követelés')">
                  <ion-icon slot="start" name="add"></ion-icon>
                  Új követelés
                </ion-button>
              </div-->
              <ng-container>
                <ngx-datatable (select)="onSelect($event)"
                  class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz" [rows]="kovetel"
                  [sortType]="SortType.single" [columnMode]="ColumnMode.force" [rowClass]="getRowClass" [sorts]="[
        { prop: 'date', dir: 'desc' }
      ]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
                  <ngx-datatable-column name="Név" prop="nev">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Név</b>
                      {{ value }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Összeg" prop="osszeg">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Összeg</b>
                      {{ value | currency: 'HUF' : '' : '0.0' }} Ft
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Dátum" prop="date">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Dátum</b>
                      <span *ngIf="value">{{ value }}</span>
                    </ng-template>
                  </ngx-datatable-column>

                </ngx-datatable>
              </ng-container>

            </ion-col>
            <ion-col size="6">
              <!--div style="margin-top: 10px;">
                <ion-button color="success" (click)="initModal2(csegyenlegid,0,'Jóváírás')">
                  <ion-icon slot="start" name="add"></ion-icon>
                  Új jóváírás
                </ion-button>
              </div-->
              <ng-container>
                <ngx-datatable (select)="onSelect($event)"
                  class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz" [rows]="jovair"
                  [sortType]="SortType.single" [columnMode]="ColumnMode.force" [rowClass]="getRowClass" [sorts]="[
        { prop: 'date', dir: 'desc' }
      ]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
                  <ngx-datatable-column name="Név" prop="nev">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Név</b>
                      {{ value }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Összeg" prop="osszeg">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Összeg</b>
                      {{ value | currency: 'HUF' : '' : '0.0' }} Ft
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Dátum" prop="date">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Dátum</b>
                      <span *ngIf="value">{{ value }}</span>
                    </ng-template>
                  </ngx-datatable-column>

                </ngx-datatable>
              </ng-container>

            </ion-col>
          </ion-row>





        </ion-grid>
      </form>

    </ion-content>
  </ng-template>
</ion-modal>



<ion-modal class="nagy" style="z-index: 1000" #osztalymodal trigger="osztaly">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-button (click)="cancelOsztaly()">Bezár</ion-button>
        </ion-buttons>
        <ion-title>Egyenlegközlő - {{oegyenleg[csegyenlegid].osztaly}}</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <table style="width: 100%;" border="1">
        <thead>

        </thead>
        <tbody>
          <tr>
            <td>Osztályfőnök</td>
            <td>{{oegyenleg[csegyenlegid].viselt_vez}} {{oegyenleg[csegyenlegid].viselt_ker}}</td>
          </tr>
          <tr *ngFor="let zseb of zsebek">
            <td [class]="csegyenleg.zseb_egyenlegek[zseb.nev] >= 0 ? 'row-color-green' : 'row-color-blue'"><b>{{zseb.nev}} zseb</b></td>
            <td [class]="csegyenleg.zseb_egyenlegek[zseb.nev] >= 0 ? 'row-color-green' : 'row-color-blue'"><b>{{csegyenleg.zseb_egyenlegek[zseb.nev] || 0 | currency: 'HUF' : '' : '0.0'}}
                Ft</b></td>
          </tr>
          <tr style="border-top:2px solid">
            <td [class]="csegyenleg.egyenleg >= 0 ? 'row-color-green' : 'row-color-blue'"><b>Összesített egyenleg</b></td>
            <td [class]="csegyenleg.egyenleg >= 0 ? 'row-color-green' : 'row-color-blue'"><b>{{csegyenleg.egyenleg | currency: 'HUF' : '' : '0.0'}}
                Ft</b></td>
          </tr>
        </tbody>
      </table>
      
        <ion-grid>

          <ion-row><!-- *ngIf="segment=='3'"-->
            <ion-col size="6">
              <!--div style="margin-top: 10px;">
                <ion-button color="primary" (click)="initModal2(csegyenlegid,0,'Követelés')">
                  <ion-icon slot="start" name="add"></ion-icon>
                  Új követelés
                </ion-button>
              </div-->
              <ng-container>
                <h2>Kiadások</h2>
                <ngx-datatable (select)="onSelect($event)"
                  class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz" [rows]="kovetel"
                  [sortType]="SortType.single" [columnMode]="ColumnMode.force" [rowClass]="getOsztalyRowClass" [sorts]="[
        { prop: 'date', dir: 'desc' }
      ]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
                  <ngx-datatable-column name="Név" prop="nev">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Név</b>
                      {{ value }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Számlaszám" prop="szlaszam">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Számlaszám</b>
                      {{ value }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Zseb" prop="alrendszer">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Zseb</b>
                      {{ value }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Összeg" prop="osszeg">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Összeg</b>
                      {{ value | currency: 'HUF' : '' : '0.0' }} Ft
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Dátum" prop="date">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Dátum</b>
                      <span *ngIf="value">{{ value }}</span>
                    </ng-template>
                  </ngx-datatable-column>

                </ngx-datatable>
              </ng-container>

            </ion-col>
            <ion-col size="6">
              <!--div style="margin-top: 10px;">
                <ion-button color="success" (click)="initModal2(csegyenlegid,0,'Jóváírás')">
                  <ion-icon slot="start" name="add"></ion-icon>
                  Új jóváírás
                </ion-button>
              </div-->
              <ng-container>
                <h2>Bevételek</h2>
                <ngx-datatable (select)="onSelect($event)"
                  class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz" [rows]="jovair"
                  [sortType]="SortType.single" [columnMode]="ColumnMode.force" [rowClass]="getOsztalyRowClass" [sorts]="[
        { prop: 'date', dir: 'desc' }
      ]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
                  <ngx-datatable-column name="Név" prop="nev">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Név</b>
                      {{ value }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Zseb" prop="alrendszer">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Zseb</b>
                      {{ value }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Összeg" prop="osszeg">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Összeg</b>
                      {{ value | currency: 'HUF' : '' : '0.0' }} Ft
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Dátum" prop="date">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                      <b class="mobil">Dátum</b>
                      <span *ngIf="value">{{ value }}</span>
                    </ng-template>
                  </ngx-datatable-column>

                </ngx-datatable>
              </ng-container>

            </ion-col>
          </ion-row>





        </ion-grid>

    </ion-content>
  </ng-template>
</ion-modal>

<!-- Tömeges ebédkiírás: minden családra kiszámítja a havi fizetendőt, listából kivehető, majd egyben kiírható. -->
<ion-modal #tomegesmodal>
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title>Tömeges ebédkiírás</ion-title>
        <ion-buttons slot="end"><ion-button (click)="tomegesmodal.dismiss()">Bezár</ion-button></ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-row class="ion-align-items-end">
        <ion-col size="4"><ion-item><ion-input type="number" label="Év" labelPlacement="stacked" [(ngModel)]="tomeges.ev"></ion-input></ion-item></ion-col>
        <ion-col size="4"><ion-item><ion-input type="number" label="Hónap" labelPlacement="stacked" [(ngModel)]="tomeges.honap"></ion-input></ion-item></ion-col>
        <ion-col size="4">
          <ion-button expand="block" (click)="tomegesSzamit()" [disabled]="tomeges.fut">
            <ion-icon slot="start" name="calculator"></ion-icon> Számítás
          </ion-button>
        </ion-col>
      </ion-row>

      <!-- Kétheti (félhavi) számlázás: a hónapon belüli nap-tartomány. -->
      <ion-row class="ion-align-items-end">
        <ion-col [size]="tomeges.idoszak === 'egyedi' ? 6 : 12">
          <ion-item>
            <ion-select label="Időszak" labelPlacement="stacked" interface="popover" [(ngModel)]="tomeges.idoszak">
              <ion-select-option *ngFor="let o of idoszakOpciok" [value]="o.id">{{ o.nev }}</ion-select-option>
            </ion-select>
          </ion-item>
        </ion-col>
        <ion-col size="3" *ngIf="tomeges.idoszak === 'egyedi'">
          <ion-item><ion-input type="number" min="1" max="31" label="Ettől" labelPlacement="stacked"
            [(ngModel)]="tomeges.nap_tol"></ion-input></ion-item>
        </ion-col>
        <ion-col size="3" *ngIf="tomeges.idoszak === 'egyedi'">
          <ion-item><ion-input type="number" min="1" max="31" label="Eddig" labelPlacement="stacked"
            [(ngModel)]="tomeges.nap_ig"></ion-input></ion-item>
        </ion-col>
      </ion-row>

      <!-- Díjbekérő minden családnak + számlatömb választás -->
      <ion-item lines="none">
        <ion-checkbox slot="start" [(ngModel)]="tomeges.dijbekero"></ion-checkbox>
        <ion-label class="ion-text-wrap">Díjbekérő generálása minden kiírt családnak</ion-label>
      </ion-item>
      <ion-item *ngIf="tomeges.dijbekero">
        <ion-select label="Számlatömb" labelPlacement="stacked" interface="popover" fill="outline"
          [(ngModel)]="tomeges.biztomb" placeholder="Válassz tömböt">
          <ion-select-option *ngFor="let t of tombok" [value]="t.id">{{ t.elotag }}</ion-select-option>
        </ion-select>
      </ion-item>

      <div *ngIf="tomeges.fut" class="ion-text-center ion-padding">
        <ion-spinner></ion-spinner>
        <p>Számítás folyamatban… {{ tomeges.halad }} / {{ tomeges.total }} család</p>
      </div>

      <ng-container *ngIf="tomeges.kesz && !tomeges.fut">
        <ion-list-header><ion-label>Fizetendő ({{ tomeges.honap }}. hónap{{ idoszakCimke(tomeges) }}) – pipáld ki, amit ki akarsz írni</ion-label></ion-list-header>
        <ion-item *ngIf="tomeges.sorok.length === 0"><ion-label color="medium">Nincs étkező család erre a hónapra (vagy nincs ki nem számlázott nap).</ion-label></ion-item>
        <ion-item *ngFor="let s of tomeges.sorok" [class.tomeges-kizart]="!s.include">
          <ion-checkbox slot="start" [(ngModel)]="s.include" [disabled]="s.osszeg <= 0"></ion-checkbox>
          <ion-label class="ion-text-wrap">
            {{ s.nev }}
            <p *ngIf="s.osszeg <= 0" style="color:var(--ion-color-medium)">nincs fizetendő</p>
          </ion-label>
          <ion-note slot="end"><b>{{ s.osszeg | currency:'HUF':'':'1.0-0' }} Ft</b></ion-note>
        </ion-item>

        <ion-item lines="none" *ngIf="tomeges.sorok.length" color="light">
          <ion-label><b>Összesen ({{ tomegesKivalasztottDb() }} család)</b></ion-label>
          <ion-note slot="end"><b>{{ tomegesOsszesen() | currency:'HUF':'':'1.0-0' }} Ft</b></ion-note>
        </ion-item>

        <ion-button expand="block" color="success" class="ion-margin-top" (click)="tomegesKiir()" [disabled]="tomegesKivalasztottDb() === 0">
          <ion-icon slot="start" name="add-circle"></ion-icon> Kijelöltek kiírása ({{ tomegesKivalasztottDb() }})
        </ion-button>
      </ng-container>
    </ion-content>
  </ng-template>
</ion-modal>
